/**
 * Convierte una fecha en formato Unix a una fecha juliana
 * @param {number} unixTime - Tiempo en formato Unix
 * @returns {number} - Fecha en formato juliana
 */
export function convert_to_ISO(unixTime) {
    const date = new Date(unixTime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const isoBasic = `${year}${month}${day}`;

    return isoBasic;
}

export function formatDate(event) {
    let input = event.target.value.replace(/\D/g, '');

    input = input.slice(0, 8);

    if (input.length > 4) {
        input = input.slice(0, 4) + '/' + input.slice(4);
    }
    if (input.length > 2) {
        input = input.slice(0, 2) + '/' + input.slice(2);
    }

    return input;
}

export function validateDate(date) {
    const [day, month, year] = date.split('/').map(Number);
    const currentDate = new Date();
    const inputDate = new Date(year, month - 1, day);

    if (month < 1 || month > 12) return false;

    const daysInMonth = new Date(year, month, 0).getDate();
    if (day < 1 || day > daysInMonth) return false;

    if (inputDate > currentDate) return false;

    if (
        inputDate.getDate() !== day ||
        inputDate.getMonth() + 1 !== month ||
        inputDate.getFullYear() !== year
    )
        return false;

    const age = getAge(inputDate);
    const MAX_AGE = 150;

    if (age < 0 || age > MAX_AGE) return false;

    return true;
}

function getAge(date) {
    const today = new Date();
    let age = today.getFullYear() - date.getFullYear();
    const m = today.getMonth() - date.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < date.getDate())) {
        age--;
    }

    return age;
}

export function formDate(ISOdate) {
    const date = new Date(ISOdate);
    return date.toLocaleDateString('es-ES', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
    });
}
